import React from "react";

interface AssetBreadcrumbProps {
  tcName?: string;
  siteName?: string;
  blockName?: string;
  levelName?: string;
}

const AssetBreadcrumb: React.FC<AssetBreadcrumbProps> = ({
  tcName,
  siteName,
  blockName,
  levelName,
}) => {
  const items = [
    { label: tcName, show: Boolean(tcName) },
    { label: siteName, show: Boolean(siteName) },
    { label: blockName, show: Boolean(blockName) },
    { label: levelName, show: Boolean(levelName) },
  ].filter((item) => item.show);

  if (items.length === 0) return null;

  return (
    <div className="mb-3">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {items.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${
                index === items.length - 1 ? "active" : ""
              }`}
              style={{ color: index === items.length - 1 ? "#000" : "#6c757d" }}
            >
              {item.label}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default AssetBreadcrumb;
